<template>
  <div class="main">
    <div class="titlefont">
      <div class="titleAnimation">
        <div class="title">{{ designProject.title }}</div>
        <div class="desc">{{ designProject.about }}</div>
      </div>
    </div>
    <div class="conMain">
      <div class="con">
        <!-- 电商 -->
        <div class="titleAnimation">
          <img :src="designProject.image[0].url" />
        </div>
        <!-- end -->
        <!-- 平面 -->
        <!-- <div v-if="subject.name === '平面设计'">
          <img src="../img/pm.png" />
        </div> -->
        <!-- end -->
        <!-- ui -->
        <!-- <div class="uiBox" v-if="subject.name === 'UI设计'">
          <img src="../img/UI.png" />
        </div> -->
        <!-- end -->
        <!-- <div class="left leftBox" v-if="designProject.info !== undefined">
          
          <div v-if="subject.name === '电商设计'">
            <ul>
              <li>苏宁单店单天销售<span>2</span>亿</li>
              <li>2020年京东双11 成交额达<span>2715</span>亿元</li>
              <li>2020年全国网上零售额达<span>11.76</span>万亿元</li>
              <li>2020年天猫双11 成交额达<span>4982</span>亿元</li>
            </ul>
            <div class="des">
              <p>购物狂欢节成交额背后，是电商行业的飞速发展</p>
              <p>
                电商不断的前行催化着艺术与商业的碰撞，电商设计师人才缺口巨大，薪资增长速度惊人
              </p>
            </div>
          </div>
          <div v-if="subject.name === '平面设计'">
            <ul>
              <li>中国超<span>3000</span>万家企业都需要logo设计</li>
              <li>小米logo改改边框，花费<span>200</span>万元</li>
              <li>百事可乐花费<span>650</span>万设计lOGO</li>
              <li>英国石油公司LOGO价值<span>13</span>亿，世界最贵</li>
            </ul>
            <div class="des">
              <p>
                平面作为UI、电商学科的基础，承载了各种软件和技术的基本能力，我们将引领全新主流的软件和技术打好地基，撑帆远航。
              </p>
            </div>
          </div>
          <div class="uiBox" v-if="subject.name === 'UI设计'">
            <div class="tit">UI鼎盛时期，厚积薄发全升级</div>
            <div class="des">
              <p>
                2021UI就业形势更加严峻，行业白热化，疫情影响，诸多企业线下转线上，造就了更多但更全面的UI机会，更强劲更高效更主流是我们当下时刻准备着的。
              </p>
            </div>
          </div>
        </div>
        <div
          class="right"
          v-if="designProject.chartsData !== undefined"
          style="opacity: 1"
        >
          <div class="tit">
            {{ designProject.info.title }}
          </div>
          <div v-if="subject.name === 'UI设计'">
            <div class="rowllInfoBox">
              <div class="chatLeftBox">
                <div
                  :class="{
                    keyfromB: index == 0,
                    keyfromD: index == 1,
                    keyfromF: index == 2,
                    keyfromH: index == 3,
                    keyfromJ: index == 4,
                  }"
                  class="row chatLeft"
                  v-for="(item, index) in contListDataes.slice(0, 5)"
                  :key="index"
                >
                  <div class="chatTit">
                    <div class="chatInfo">{{ item }}</div>
                  </div>
                </div>
              </div>
              <div class="chatRitBox">
                <div
                  :class="{
                    keyfromA: index == 0,
                    keyfromC: index == 1,
                    keyfromE: index == 2,
                    keyfromG: index == 3,
                    keyfromI: index == 4,
                  }"
                  class="row chatRight"
                  v-for="(item, index) in contListDataes.slice(5, 10)"
                  :key="index"
                >
                  <div class="chatTit">
                    <div class="chatInfo">{{ item }}</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="text chaiInfo">
              <div><span class="cryIcon"></span>没有APP/小程序的生活</div>
              <div><span class="happyIcon"></span>拥有APP/小程序的生活</div>
            </div>
          </div>

          <chart
            v-else
            height="90%"
            width="100%"
            :chartsData="designProject.chartsData"
          />
        </div> -->
      </div>
      <div class="rightTIcon"></div>
      <div class="leftTIcon"></div>
    </div>
  </div>
</template>

<script>
// import Chart from "./../../../../components/Charts/LineMarker";
export default {
  name: "design",
  components: {
    // Chart,
  },
  props: {
    designProject: {
      type: Object,
      default: () => {},
    },
    subject: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      contListDataes: [
        "出行除了公交、出租别无选择。",
        "吃饭聚餐除了亲自下厨就是外出下馆子。",
        "购物只能去商场，选择少，价格也高。",
        "亲友联系只能电话，或者短信。",
        "一生好长，可圈子好小。",
        '"滴滴出行"、"花小猪"、"滴答出行"等助你方便出行。',
        '"饿了么"、"美团外卖"等让你吃饭有更多的选择。',
        '"淘宝"、"京东"、"唯品会"等让你在家就能逛遍全世界。',
        '"微信"让我们的沟通更加多元趣味性，联系无压力。',
        '"陌陌"、"探探"等告诉你世界有多大，圈子就有多大。',
      ],
    };
  },
  beforeMount() {
    console.log(this.designProject, 2);
  },
  mounted() {
    console.log(this.designProject, 3);
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.scrollTg1Show .chaiInfo {
  animation: keyFromShow 1s ease 0s forwards;
}
.scrollTg1Show .keyfromA {
  animation: keyFromShow 1s ease 0.5s forwards;
}
.scrollTg1Show .keyfromB {
  animation: keyFromShow 1s ease 1s forwards;
}
.scrollTg1Show .keyfromC {
  animation: keyFromShow 1s ease 1.5s forwards;
}
.scrollTg1Show .keyfromD {
  animation: keyFromShow 1s ease 2s forwards;
}
.scrollTg1Show .keyfromE {
  animation: keyFromShow 1s ease 2.5s forwards;
}
.scrollTg1Show .keyfromF {
  animation: keyFromShow 1s ease 3s forwards;
}
.scrollTg1Show .keyfromG {
  animation: keyFromShow 1s ease 3.5s forwards;
}
.scrollTg1Show .keyfromH {
  animation: keyFromShow 1s ease 4s forwards;
}
.scrollTg1Show .keyfromI {
  animation: keyFromShow 1s ease 4.5s forwards;
}
.scrollTg1Show .keyfromJ {
  animation: keyFromShow 1s ease 5s forwards;
}
.showAnimat5 .keyfrom51 {
  animation: keyFromShow 1s ease 5.5s forwards;
}
.showAnimat5 .keyfrom52 {
  animation: keyFromShow 1s ease 300ms forwards;
}
.showAnimat5 .keyfrom53 {
  animation: keyFromShow 1s ease 600ms forwards;
}
.showAnimat5 .keyfrom54 {
  animation: keyFromShow 1s ease 900ms forwards;
}
.showAnimat5 .keyfrom55 {
  animation: keyFromShow 1s ease 1200ms forwards;
}
@keyframes keyFromShow {
  0% {
    opacity: 0;
    top: 100px;
  }
  100% {
    opacity: 1;
    top: 0px;
  }
}
</style>
